import { useState } from "react";
import { usePwaInstall } from "./usePwaInstall";

const COPY = {
  pl: {
    eyebrow: "Aplikacja",
    title: "Zainstaluj Morfeusza",
    text: "Dodaj Morfeusz Dreams do urządzenia, aby wracać do Pokoiku jak do aplikacji.",
    installed: "Aplikacja jest już zainstalowana na tym urządzeniu.",
    unavailable: "Instalacja pojawi się, gdy przeglądarka udostępni przycisk instalacji. Możesz też użyć menu przeglądarki.",
    ios: "Na iPhonie/iPadzie otwórz stronę w Safari → Udostępnij → Dodaj do ekranu początkowego.",
    install: "Zainstaluj aplikację",
    installing: "Otwieram instalację…",
    accepted: "Instalacja została rozpoczęta.",
    dismissed: "Instalacja została zamknięta.",
    error: "Nie udało się uruchomić instalacji.",
  },
  en: {
    eyebrow: "App",
    title: "Install Morpheus",
    text: "Add Morpheus Dreams to this device and return to your Room like to an app.",
    installed: "The app is already installed on this device.",
    unavailable: "Installation will appear when your browser makes it available. You can also use the browser menu.",
    ios: "On iPhone/iPad, open this page in Safari → Share → Add to Home Screen.",
    install: "Install app",
    installing: "Opening installation…",
    accepted: "Installation has started.",
    dismissed: "Installation was closed.",
    error: "Could not start installation.",
  },
};

export const PwaInstallPanel = ({ lang = "pl" }) => {
  const copy = COPY[lang] || COPY.pl;
  const pwa = usePwaInstall();
  const [status, setStatus] = useState("");

  const handleInstall = async () => {
    setStatus(copy.installing);
    const result = await pwa.install();
    if (result === "ios") setStatus(copy.ios);
    else if (result === "accepted") setStatus(copy.accepted);
    else if (result === "dismissed") setStatus(copy.dismissed);
    else if (result === "unavailable") setStatus(copy.unavailable);
    else if (result === "error") setStatus(copy.error);
    else setStatus("");
  };

  return (
    <div className="mdCard" data-ui="profile-pwa-card">
      <div className="mdCard__header">
        <p className="mdPage__eyebrow" data-ui="profile-pwa-eyebrow">{copy.eyebrow}</p>
      </div>
      <h2 data-ui="profile-pwa-title">{copy.title}</h2>
      <p className="mdPage__subtitle" data-ui="profile-pwa-text">
        {pwa.installed ? copy.installed : copy.text}
      </p>
      {!pwa.installed && (
        <div className="mdRow" data-ui="profile-pwa-actions">
          <button type="button" className="mdBtn mdBtn--primary mdBtn--row" onClick={handleInstall} disabled={pwa.busy} data-ui="profile-pwa-install">
            {pwa.busy ? copy.installing : copy.install}
          </button>
        </div>
      )}
      {!pwa.installed && pwa.isIosSafari && <div className="mdAlert mdAlert--info" data-ui="profile-pwa-ios">{copy.ios}</div>}
      {!pwa.installed && !pwa.canInstall && !pwa.isIosSafari && <div className="mdAlert mdAlert--info" data-ui="profile-pwa-unavailable">{copy.unavailable}</div>}
      {status && <div className="mdAlert mdAlert--info" data-ui="profile-pwa-status" role="status">{status}</div>}
    </div>
  );
};
